// extracted by mini-css-extract-plugin
export default {"container":"CrossProgramRelationships_container__aF-0r","header":"CrossProgramRelationships_header__Vit7J","overflow":"CrossProgramRelationships_overflow__1BynG"};